import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { Button, ButtonGroup, Spinner, Table } from 'react-bootstrap';
import { FaRegEdit, FaTimesCircle } from 'react-icons/fa';
import { MenuMaster } from "../../../models/config/MenuMaster";

export type MenuMasterTableProps = {
    menus?: MenuMaster[];
    isPending?: boolean;
    onEdit?: (menuMasters: MenuMaster[]) => void;
    onDelete?: (menuMasters: MenuMaster[]) => void;
};

export const MenuMasterTable = (props: MenuMasterTableProps) => {
    const { isPending, menus, onEdit, onDelete } = props;

    const menuGroups = useMemo(() => {
        if (!menus) {
            return undefined;
        }

        const output = new Map<string, MenuMaster[]>();
        menus.forEach(menu => {
            if (!output.has(menu.id)) {
                output.set(menu.id, []);
            }
            output.get(menu.id)!.push(menu);
        });

        return Array.from(output);
    }, [menus]);

    return (
        <div className="mt-3">
            <Table className="table-bordered table-hover custom-table-list table-responsive-lg" size="sm">
                <thead>
                    <tr style={{ width: '100%' }} className="text-center table-active thead-light require-field">
                        <th style={{ width: '5%', top: -1, position: 'sticky', zIndex: 1 }} />
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Menu ID</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Menu Name</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Created On</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Created By</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Updated On</th>
                        <th style={{ top: -1, position: 'sticky', zIndex: 1 }}>Updated By</th>
                    </tr>
                </thead>
                <tbody>
                    {isPending ? (
                        <tr>
                            <td colSpan={7} style={{ background: "rgba(209, 250, 221, 1)", color: "black", fontSize: '10pt', textAlign: "center" }}>
                                <Spinner animation="border" size="sm" />{' '}Loading...
                            </td>
                        </tr>
                    ) : !menuGroups?.length ? (
                        <tr>
                            <td colSpan={7} style={{ background: "#b7b7a4", color: "black", fontSize: '10pt', textAlign: "center" }}>No Data.</td>
                        </tr>
                    ) : (
                        menuGroups.map(([menuId, menus]) => {
                            const menu = menus[0] ?? {};

                            const formattedCreatedOn = menu.created_on
                                ? dayjs(menu.created_on, 'YYYYMMDDHHmmss').format('DD/MM/YYYY HH:mm น.')
                                : undefined;

                            const formattedUpdatedOn = menu.updated_on
                                ? dayjs(menu.updated_on, 'YYYYMMDDHHmmss').format('DD/MM/YYYY HH:mm น.')
                                : undefined;

                            return (
                                <tr key={menuId}>
                                    <td className="text-center" style={{ width: '5%' }}>
                                        <ButtonGroup>
                                            <Button size="sm" variant="info" onClick={() => onEdit?.(menus)}>
                                                <FaRegEdit />
                                            </Button>
                                            <Button size="sm" variant="danger" onClick={() => onDelete?.(menus)}>
                                                <FaTimesCircle />
                                            </Button>
                                        </ButtonGroup>
                                    </td>
                                    <td>{menu.id}</td>
                                    <td>{menu.menu_name}</td>
                                    <td>{formattedCreatedOn}</td>
                                    <td>{menu.created_by}</td>
                                    <td>{formattedUpdatedOn}</td>
                                    <td>{menu.updated_by}</td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
        </div>
    );
};
